<template>
  <section>
    <div class="settings-header">
      {{ __('Integração de Formulários') }}
      <span class="badge badge-box">BETA</span>
    </div>
    <div class="row">
      <div class="col-12">
        <h4>{{ __('Código de Integração') }}</h4>
        <p class="form-text">
          {{ __('Este script é responsável por identificar e integrar os formulários do seu site') }}.
          {{ __('Ele identifica os formulários do seu site e cria uma integração relacionada com ele') }}.
        </p>
        <p class="form-text">
          {{ __('Adicione em todas as páginas do seu site dentro da tag') }} <code>&lt;head&gt;</code> {{ __('e tenha controle sobre a configuração de cada integração de formulário') }}.
        </p>
        <div class="form-group">
          <textarea
            class="form-control"
            rows="10"
            onclick="this.focus();this.select();document.execCommand('copy');"
            v-model="code"
            readonly="readonly"
          />
        </div>
        <hr>
        <h4>{{ __('Formulários') }}</h4>
        <div
          class="row"
          v-if="loading"
        >
          <div class="col-12">
            <i class="fa fa-circle-o-notch fa-spin mt-4" />
          </div>
        </div>
        <template v-else-if="forms.length">
          <p class="form-text">
            {{ __('Configure as suas integrações de formulários') }}.
          </p>
          <p class="form-text">
            {{ __('Você pode definir o mapeamento dos campos, se a integração está ativa ou se deve ser validada') }}.
          </p>
          <div class="row">
            <div class="col-12">
              <ul class="settings-group list-group mt-4">
                <li
                  class="list-group-item d-flex align-items-center"
                  :key="form.id"
                  v-for="(form, index) in forms"
                >
                  <span v-if="form.identifier">{{ form.identifier }}</span><span v-else>{{ __('Formulário sem nome') }} {{ (index + 1) }}</span><i
                    class="fa fa-chevron-right mx-2"
                    style="font-size: 0.625rem;"
                  /><strong class="mr-1">{{ __('Localizado em') }}:</strong><span class="mr-3"> {{ form.domain }}</span>
                  <ToggleButton
                    class="ml-auto mb-0"
                    v-bind="toggler"
                    v-b-tooltip="form.active ? 'Formulário ativo' : 'Formulário inativo'"
                    :value="form.active"
                    @change="toggle(form, $event.value)"
                  /><a
                    class="ml-3 mt-n1px"
                    href="#"
                    v-b-tooltip.left="'Editar formulário'"
                    @click.prevent="open(form)"
                    v-if="update"
                  >
                    <IconPencilFilled :size="18" /></a><a
                    class="ml-3 mt-n1px"
                    href="#"
                    v-b-tooltip.left="'Excluir formulário'"
                    @click.prevent="remove(form)"
                    v-if="destroy"
                  >
                    <IconTrash :size="18" /></a>
                </li>
              </ul>
            </div>
          </div>
        </template>
        <div
          class="row"
          v-else
        >
          <div class="col-12">
            <div class="mt-4">
              <p class="form-text">
                {{ __('Nenhum formulário identificado, verifique se o código de integração foi adicionado corretamente no seu site') }}.
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
    <BModal
      id="form-setting-modal"
      ref="form-setting-modal"
      modal-class="modal-width-380"
      hide-footer="hide-footer"
    >
      <template slot="modal-header">
        <div class="modal-title">
          {{ __('Editar Integração de Formulário') }}
        </div>
        <button
          class="close"
          type="button"
          data-dismiss="modal"
          aria-label="Close"
          @click="close"
        >
          <span aria-hidden="true"><img
            class="mb-5px"
            src="/build/icons/close@white.svg"
            width="14"
            height="13"
          ></span>
        </button>
      </template>
      <template slot="default">
        <form @submit.prevent="save(form)">
          <div class="form-group">
            <label for="field-description">{{ __('Nome do Formulário') }}</label>
            <input
              class="form-control"
              type="text"
              v-model="form.identifier"
            >
          </div>
          <div class="form-group">
            <label>{{ __('Mapeamento dos campos') }}</label>
            <table
              class="table table-bordered"
              v-show="fields.length"
            >
              <thead>
                <tr>
                  <th>{{ __('Campo do formulário') }}</th>
                  <th>{{ __('Campo customizado') }}</th>
                </tr>
              </thead>
              <tbody>
                <tr
                  :key="label"
                  v-for="(field, label) in form.map"
                >
                  <td style="width: 50%">
                    <span v-text="label" />
                  </td>
                  <td style="width: 50%">
                    <select
                      class="form-control"
                      v-model="form.map[label]"
                    >
                      <option :value="label" />
                      <option
                        :key="field.identifier"
                        v-for="field in fields"
                        :value="field.identifier"
                      >
                        {{ field.description }}
                      </option>
                    </select>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
          <div class="form-group">
            <div class="form-check">
              <label class="form-check-label">
                <input
                  class="form-check-input"
                  type="checkbox"
                  v-model="form.validate"
                >{{ __('Validar formulário usando HTML5') }}
              </label>
            </div>
          </div>
          <div class="modal-footer default-modal-footer">
            <button
              class="btn btn-white"
              type="button"
              :disabled="saving"
              @click.prevent="close"
            >
              {{ __('Cancelar') }}
            </button>
            <button
              class="btn btn-box-success"
              type="submit"
              :disabled="saving"
            >
              <span v-if="saving">{{ __('Salvando') }}...</span><span v-else>{{ __('Salvar') }}</span>
            </button>
          </div>
        </form>
      </template>
    </BModal>
  </section>
</template>

<script>
import { BModal, VBTooltip } from 'bootstrap-vue';
import { Confirm } from '../../services/Confirm';

export default {
  components: {
    BModal,
  },

  directives: {
    'b-tooltip': VBTooltip,
  },

  props: {
    update: {
      type: Boolean,
      default: false,
      required: false,
    },

    destroy: {
      type: Boolean,
      default: false,
      required: false,
    },

    url: {
      type: String,
      required: true,
    },

    token: {
      required: true,
    },
  },

  data: () => ({
    form: {},
    forms: [],
    fields: [],
    saving: false,
    loading: true,
  }),

  created () {
    this.fetch();

    Bus.$on('fieldsRetrieved', (fields) => this.fields = fields);
  },

  computed: {
    toggler: () => ({
      width: 35,
      height: 19,
      color: '#00c71f',
    }),

    code () {
      // eslint-disable-next-line no-useless-escape
      return `<script>\n  window.BulldeskSettings = {\n    token: '${this.token}'\n  };\n\n  !function(a,b,c){if('object'!=typeof c){var d=function(){d.c(arguments)};d.q=[],d.c=function(a){d.q.push(a)},a.Bulldesk=d;var e=b.createElement('script');e.type='text/javascript',e.async=!0,e.id='bulldesk-analytics',e.src='${this.url}';var f=b.getElementsByTagName('script')[0];f.parentNode.insertBefore(e,f)}}(window,document,window.Bulldesk);\n<\/script>`;
    },
  },

  methods: {
    fetch () {
      this.loading = true;

      this.$http.get('/settings/form')
        .then(({ data }) => {
          this.forms = data.filter((form) => ! form.from_builder);
        })
        .catch(() => {
          // Alert.error('Erro ao listar formulários');
        })
        .finally(() => {
          this.loading = false;
        });
    },

    save (form) {
      this.saving = true;

      this.$http.put(`/settings/form/${form.id}`, form)
        .then(({ data }) => {
          this.$set(this.forms, this.forms.findIndex(({ id }) => id === data.id), data);
        })
        .catch(() => {
          Alert.error(this.__('Erro ao atualizar formulário.'));
        })
        .finally(() => {
          this.saving = false;

          this.close();
        });
    },

    toggle (form, flag) {
      form.active = flag;

      this.save(form);
    },

    async remove (form) {
      if (! await Confirm(this.__('Deseja mesmo excluir este formulário?'))) {
        return;
      }

      this.$http.delete(`/settings/form/${form.id}`)
        .then(() => {
          this.$delete(this.forms, this.forms.findIndex(({ id }) => id === form.id));
        })
        .catch(() => {
          Alert.error(this.__('Erro ao apagar formulário.'));
        });
    },

    open (form) {
      /**
         * Remove deep reference.
         */
      this.form = JSON.parse(JSON.stringify(form));

      this.$refs['form-setting-modal'].show();
    },

    close () {
      this.$refs['form-setting-modal'].hide();
    },
  },
};
</script>
